import { render, staticRenderFns } from "./left-box.vue?vue&type=template&id=10860c02&"
import script from "./left-box.vue?vue&type=script&lang=js&"
export * from "./left-box.vue?vue&type=script&lang=js&"
import style0 from "./left-box.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports